var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"active-workout-page"},[_c('timer',{attrs:{"paused":_vm.isItPaused,"time":_vm.timeLeftMs},on:{"onPause":_vm.pause,"onResume":_vm.resume,"onStop":_vm.stop,"onForward":_vm.forward,"onBackward":_vm.backward}},[_vm._v(" "+_vm._s(_vm._f("timeformat")(_vm.timeLeftMs,{ showHours: true }))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }